export const locale = {
  lang: 'zh2',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE':'测绘控制',
       'CHAN_INFO':'加载信息',
       'TEX_INTRUCC':'* 通过选择过滤器执行搜索',
       'SELEC_INSTI':'研究所',
       'SELEC_YEA':'年份',
       'SELEC_TI_ENC':'产品',
       'SELEC_ESTA':'状态',
       'BTN_FIL_INFO':'过滤调查',
       'COMFI_UPDA_TEX':'确定要更新吗？',
       'BTN_ACEP':'接受',
       'BTN_CANC':'取消',
       'TEX_MOD_UPTD':'更新中',
       'TEX_SUCC_MOD_UPTD':'升级成功',
       'USE':'用户:',
       'DAT':'日期：',
       'ACC':'动作：',
       'ACC_EVENT':{
       '0':'停用',
       '1':'启用',
     },
      'NAM_TH':{
        'TH_NAM':'公司',
         'TH_TI_ENCU':'调查类型',
         'TH_DAT_APLI':'申请日期',
         'TH_ESTA':'状态',
         'TH_TOKE':'令牌',
         'TH_HC':'HC',
         'TH_RESPU':'响应',
         'TH_DAT_CLO':'截止日期',
         'TH_PRORR':'翻转',
         'TH_REPO_EXC':'Excel 报告',
         'TH_ONLI':'在线',
         'TH_OFFLI':'离线',
         'TH_AUDIT':'审核',
         'TH_SECT':'扇区',
         'TH_SUBSECT':'子扇区',
         'TH_LIPROY':'项目负责人',
         'TH_JEFPROY':'项目负责人',
      }
    },

  }
};
